import { Stack } from '@mui/material'

import { InspectionStatusWithEntries } from '../../models/inspections'
import { InspectionResultSummaryChip } from './InspectionResultSummaryChip'

export const InspectionSummaryBar = ({
  entriesByStatus
}: {
  entriesByStatus: InspectionStatusWithEntries[]
}) => {
  return (
    <Stack
      direction={{ xs: 'column', md: 'row' }}
      spacing={2}
      sx={{ width: '100%' }}>
      {entriesByStatus.map((status) => (
        <InspectionResultSummaryChip
          key={status.id!}
          statusWithEntries={status}
        />
      ))}
    </Stack>
  )
}
